import React, { KeyboardEvent, useEffect, useRef } from "react";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { ReactComponent as ClearImg } from "../../assets/icons/x.svg";
import Keyboard from "../Keyboard";
import orderStore from "../../stores/order";
import { observer } from "mobx-react";
import { cutScannerData } from "../../helpers/orderHelper";

export interface EnterInternalCardProps {
    goNext?: () => void;
}

const EnterInternalCard = ({goNext}: EnterInternalCardProps) => {
    const [t] = useTranslation();
    const inputRef = useRef(null);
    const clearRef = useRef(null);

    let timer: NodeJS.Timeout;

    useEffect(() => {
        timer = setInterval(() => {
            setFocusToInput();
        }, 500);
        setFocusToInput();

        return () => {
            clearInterval(timer);
        }
    }, []);

    const setFocusToInput = () => {
        if (inputRef.current) {
            const input = inputRef.current as unknown as HTMLInputElement;
            input.focus();
        }
    }

    const onChangeText = (text: string) => {
        text = cutScannerData(text);
        orderStore.changeInternalCard(text);
    }

    const onChangeTextInput = (text: string) => {
        const isGoNext = !orderStore.internalCard.length && text.length > 3;
        onChangeText(text);

        if (isGoNext && typeof goNext === "function")
            goNext();
    }

    const keyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && typeof goNext === "function")
            goNext();
    }

    return <div className="EnterInternalCard">
        <div className="title">{t('internalCard')}</div>
        <div className="description">{t('internalCardDescription')}</div>
        <div className="inputContainer">
            <div className="input">{orderStore.internalCard}</div>
            <ClearImg ref={clearRef} className="clear" />
        </div>
        <input ref={inputRef} className="inputHide" type="text" value={orderStore.internalCard} onChange={(e) => onChangeTextInput(e.target.value)} onKeyDown={keyDown} />
        <Keyboard clearRef={clearRef} onChangeText={onChangeText} text={orderStore.internalCard} />
    </div>
}

export default observer(EnterInternalCard);